var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.516 21.5459H68.3398V32.2141H108.516V21.5459Z",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9634 21.5457C33.027 21.5457 41.999 12.5671 41.999 1.49512H1.92773C1.92773 12.5671 10.8997 21.5457 21.9634 21.5457Z",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9985 1.49512C41.9985 12.5671 33.0266 21.5457 21.9629 21.5457H108.478C119.541 21.5457 128.513 12.5671 128.513 1.49512H41.9985Z",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.012 98.0026C110.076 96.3205 106.879 94.459 103.674 92.5302C102.778 91.9919 102.165 91.5732 101.754 91.2667C101.747 90.721 101.747 90.078 101.747 89.5398V88.9566C101.747 83.6263 101.747 47.7789 101.747 32.2139H75.0998C75.0998 47.7789 75.0998 83.6188 75.0998 88.9492V89.5024C75.0848 98.4212 76.2128 107.108 89.9285 115.377C100.365 121.664 110.397 127.107 113.012 128.505V98.0026Z",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2276 44.4443C25.2276 44.4443 1.49414 63.6502 1.49414 84.3287C1.49414 97.4491 12.1245 108.08 25.2276 108.08C38.3307 108.08 48.9611 97.4416 48.9611 84.3287C48.9611 63.6502 25.2276 44.4518 25.2276 44.4518V44.4443Z",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2284 95.3861C19.1326 95.3861 14.1797 90.422 14.1797 84.3291",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0996 61.0938H101.747",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceThree);
export default __webpack_public_path__ + "static/media/serviceThree.b9827d06d02e30b1a8056a0311763f60.svg";
export { ForwardRef as ReactComponent };